import type { BaseIconProps } from './base-provider-icon'
import { BaseProviderIcon } from './base-provider-icon'

/**
 * The Trucker Tools icon component
 */
export const TruckerToolsIcon = ({ size }: BaseIconProps) => {
  return (
    <BaseProviderIcon
      size={size}
      src="https://chaine-images.s3.amazonaws.com/product-app-images/logos/trucker-tools.svg"
      label="trucker-tools-icon"
    />
  )
}
